export class ColumnModel {
  constructor(id, numeric, disablePadding, label, width) {
    this.id = id;
    this.numeric = numeric;
    this.disablePadding = disablePadding;
    this.label = label;
    this.width = width;
  }
}
